function hideDisplayQtyField(element, value) {
  const rowDiv = $("#" + element).parents(".row");
  const displayQtyField = rowDiv.next(".row").next(".row");

  value === "carousel" ? displayQtyField.hide() : displayQtyField.show();
}

function resetOrdering() {
  // Reset the visible Ordering value after each remove
  var row_count = 1;
  $(".nested-fields:visible [id*='_ordering']").each(function () {
    $(this).val(row_count++);
  });
}

function updateFeaturePostPreview(select) {
  const selected = $(select).find('option:selected');
  const preview = $(select).closest('.nested-fields').find('.feature-post-preview');
  const image = selected.data('image');
  const title = selected.data('title');
  const subtitle = selected.data('subtitle');

  if (title) {
    preview.find('.feature-post-preview-img').attr('src', image || '');
    preview.find('.feature-post-preview-img-square').attr('src', selected.data('imageSquare') || '');
    preview.find('.feature-post-preview-link').attr('href', selected.data('url') || '#');
    preview.find('.feature-post-preview-title').text(title);
    preview.find('.feature-post-preview-subtitle').text(subtitle || '');
    preview.removeClass('d-none');
  } else {
    preview.addClass('d-none');
  }
}

$(document).on("turbo:load", function () {
  $('.feature-post-select').each(function () { updateFeaturePostPreview(this); });
  $(document).off('change.featurePostPreview').on('change.featurePostPreview', '.feature-post-select', function () {
    updateFeaturePostPreview(this);
  });
  $(".view_types input[type=radio]:checked").each(function () {
    hideDisplayQtyField(this.id, this.value);
  });

  $(document).off("change.viewTypes").on(
    "change.viewTypes",
    ".view_types input[type=radio]:checked",
    function () {
      hideField(this.id, this.value);
    }
  );

  // Auto increment on the Ordering
  $(".simple_form").off("cocoon:after-insert.ordering").on("cocoon:after-insert.ordering", function (e, inserted) {
    resetOrdering();
    $(inserted).find('.feature-post-select').each(function () { updateFeaturePostPreview(this); });
  });
});
